import React from "react";
import usePermissions from "../hooks/usePermissions";
import NoAccess from "./NoAccess";

// Route guard: renders children only if the user holds `permission`. If not, it
// keeps the user inside the platform (header + sidebar) and shows a "not enough
// access" panel in the content area rather than redirecting out. FE gate mirrors
// the proxy's server-side enforcement (the real trust boundary) — this is UX.
export default function RequirePermission({ permission, children }) {
  const { has, loading } = usePermissions();
  if (loading) return null; // avoid flashing the page before perms resolve
  if (!has(permission)) return <NoAccess />;
  return children;
}
